var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
import * as React from "react";
function SvgTm(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7303_38688)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 0C11.104 0 10.2313 0.0990469 9.39135 0.285234L8.86963 12L9.39135 23.7147C10.2313 23.9009 11.1041 24 12 24C18.6274 24 24 18.6274 24 12C23.9999 5.37258 18.6274 0 12 0V0Z",
    fill: "#496E2D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.13041 3.91739C1.18584 6.05001 0 8.88642 0 12C0 15.1135 1.18589 17.9499 3.13045 20.0826L3.65217 12L3.13041 3.91739Z",
    fill: "#496E2D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5509 9.05151C18.1413 7.40592 17.478 5.61618 16.0546 4.72481C16.3106 4.75814 16.5669 4.81842 16.8199 4.90912C18.7185 5.59031 19.7054 7.6815 19.0242 9.58003C18.343 11.4787 16.2518 12.4655 14.3532 11.7843C14.1002 11.6936 13.864 11.5771 13.6453 11.4401C15.3107 11.657 16.9605 10.6971 17.5509 9.05151V9.05151Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.2766 4.27373L13.7636 4.93663L12.9747 4.65356L13.4465 5.34627L12.9336 6.00909L13.7382 5.77443L14.2101 6.46706L14.2355 5.62931L15.0401 5.3946L14.2513 5.11162L14.2766 4.27373Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.6617 6.43369L15.1486 7.09654L14.3597 6.81347L14.8316 7.50619L14.3186 8.169L15.1232 7.93425L15.5952 8.62701L15.6206 7.78922L16.4252 7.55447L15.6363 7.27144L15.6617 6.43369Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.8342 5.06038L11.3212 5.72319L10.5323 5.44021L11.0042 6.13288L10.4912 6.79574L11.2958 6.56103L11.7677 7.25371L11.7931 6.41596L12.5977 6.18125L11.8089 5.89818L11.8342 5.06038Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.7779 7.53455L11.2649 8.19741L10.476 7.91437L10.9479 8.60709L10.4348 9.26991L11.2395 9.03525L11.7114 9.72787L11.7368 8.89012L12.5414 8.65542L11.7525 8.37234L11.7779 7.53455Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.1321 8.37927L13.6191 9.04208L12.8302 8.75905L13.3022 9.45177L12.7891 10.1145L13.5938 9.87988L14.0657 10.5726L14.091 9.73476L14.8957 9.5001L14.1067 9.21707L14.1321 8.37927Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.13037 3.9174V20.0826C4.76537 21.8757 6.93709 23.1707 9.39123 23.7147V0.285248C6.93704 0.829279 4.76542 2.1242 3.13037 3.9174V3.9174Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.51961 6.31805L4.47144 5.53721V4.43297L5.51961 3.65218H7.00203L8.0502 4.43297V5.53721L7.00203 6.31805H5.51961Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.26084 3.65218H5.51961L4.47144 4.43297V4.97283H6.26084V3.65218Z",
    fill: "#FF9811"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.26074 6.31805H7.00193L8.0501 5.5372V4.97391H6.26074V6.31805Z",
    fill: "#FF9811"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.51961 20.3477L4.47144 19.5669V18.4627L5.51961 17.6819H7.00203L8.0502 18.4627V19.5669L7.00203 20.3477H5.51961Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.26084 17.6819H5.51961L4.47144 18.4627V19.0026H6.26084V17.6819Z",
    fill: "#FF9811"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.26074 20.3477H7.00193L8.0501 19.5669V19.0036H6.26074V20.3477Z",
    fill: "#FF9811"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.51961 13.3329L4.47144 12.5521V11.4479L5.51961 10.667H7.00203L8.0502 11.4479V12.5521L7.00203 13.3329H5.51961Z",
    fill: "#496E2D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.08694 15.0509H7.63038V14.5944H6.82811L6.26083 14.0271L5.6936 14.5944H4.89133V15.0509H4.43481V15.9639H4.89133V16.4204H5.69355L6.26088 16.9877L6.82811 16.4204H7.63038V15.9639H8.08694V15.0509Z",
    fill: "#496E2D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.08694 8.03597H7.63038V7.57941H6.82811L6.26083 7.01213L5.6936 7.57941H4.89133V8.03597H4.43481V8.94901H4.89133V9.40552H5.69355L6.26088 9.9729L6.82811 9.40552H7.63038V8.94901H8.08694V8.03597Z",
    fill: "#496E2D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.73901 11.4782H6.7825V12.5217H5.73901V11.4782Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.26073 9.01402C6.54887 9.01402 6.78245 8.78044 6.78245 8.4923C6.78245 8.20416 6.54887 7.97058 6.26073 7.97058C5.97259 7.97058 5.73901 8.20416 5.73901 8.4923C5.73901 8.78044 5.97259 9.01402 6.26073 9.01402Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.26073 16.0293C6.54887 16.0293 6.78245 15.7957 6.78245 15.5076C6.78245 15.2194 6.54887 14.9858 6.26073 14.9858C5.97259 14.9858 5.73901 15.2194 5.73901 15.5076C5.73901 15.7957 5.97259 16.0293 6.26073 16.0293Z",
    fill: "#D80027"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7303_38688"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTm);
export default __webpack_public_path__ + "static/media/tm.0d7c780d5e04c1b3fb05a4c42dc465e4.svg";
export { ForwardRef as ReactComponent };